// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2033":"b0301b60","8509":"1717b940"}[chunkId] + ".chunk.css";
};